// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Button,
  // Icon,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  // DialogContentText,
  // Tooltip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import PieChart from "examples/Charts/PieChart";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import GoogleMapReact from "google-map-react";
import MDButton from "components/MDButton";
import AppConfig from "appConfig";
import { useAuthUser } from "react-auth-kit";

// function CaptureLocationPin() {
//   return (
//     <div>
//       <Icon color="error">location_pin</Icon>
//     </div>
//   );
// }

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

function DataCampaignOverview() {
  const pageTitle = "Campaign Overview";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [overview, setOverview] = useState(null);
  const [dataMetrics, setDataMetrics] = useState(null);
  const [groupMetrics, setGroupMetrics] = useState(null);
  const [supervisorMetrics, setSupervisorMetrics] = useState(null);
  const [breakdown, setBreakdown] = useState({});
  const [locationPoints, setLocationPoints] = useState([]);
  const [mapZoom, setMapZoom] = useState(6);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/${ref}/overview.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data);
            // setCurrency(result.data.data.currency);
            setOverview(result.data.data.overview);
            setBreakdown(result.data.data.overview.breakdown);
            setDataMetrics(result.data.data.dataMetrics);
            setGroupMetrics(result.data.data.groupMetrics);
            setSupervisorMetrics(result.data.data.supervisorMetrics);
            setLocationPoints(result.data.data.overview.locationPoints);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function getPieChartColors(data) {
    const colors = ["info", "primary", "secondary", "error", "warning", "success"];
    const bgColors = [];
    data.every(() => {
      bgColors.push(colors[Math.floor(Math.random() * colors.length)]);
      return true;
    });

    return bgColors;
  }

  function getPieChartLabels(data) {
    const labels = [];
    data.every((row) => {
      labels.push(row.label);
      return true;
    });

    return labels;
  }

  function getPieChartData(data) {
    const datas = [];
    data.every((row) => {
      datas.push(row.count);
      return true;
    });

    return datas;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {overview !== null && (
        <MDBox>
          <MDBox mt={3} mb={2} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/campaigns`);
                }}
              >
                Campaigns
              </Button>
            </MDBox>
            <MDBox>
              <Button
                color="dark"
                size="small"
                onClick={() => setRefreshPage(!refreshPage)}
                startIcon={<Icon color="dark">sync</Icon>}
              >
                Refresh
              </Button>
              <Button
                color="dark"
                size="small"
                onClick={() => navigate(`/data-summary/${ref}`)}
                startIcon={<Icon color="secondary">summarize</Icon>}
              >
                Summary
              </Button>
              <Button
                color="dark"
                size="small"
                onClick={() => navigate(`/data-captures/${ref}`)}
                startIcon={<Icon color="info">list</Icon>}
              >
                Records
              </Button>
              <Button
                color="dark"
                size="small"
                onClick={() => navigate(`/campaigns/${ref}/agent-performance`)}
                startIcon={<Icon color="warning">support_agent</Icon>}
              >
                Agent Stats
              </Button>
              <Button
                color="dark"
                size="small"
                onClick={() => navigate(`/campaigns/${ref}/settings`)}
                startIcon={<Icon color="dark">settings</Icon>}
              >
                Manage
              </Button>
            </MDBox>
          </MDBox>
          <MDBox pt={3} pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={3}>
                        <MDBox align="center">
                          <Icon color="info" fontSize="large">
                            checklist
                          </Icon>
                        </MDBox>
                        <MDBox>
                          <MDBox align="center">
                            <MDTypography variant="h6" fontWeight="medium" fontSize={32}>
                              {overview.total.toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              Total Captures
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                  <MDBox mt={5.9}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={3}>
                        <MDBox align="center">
                          <MDTypography variant="h6" fontSize={28} color="success">
                            {overview.currency}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDBox align="center">
                            <MDTypography variant="h6" fontWeight="medium" fontSize={32}>
                              {(overview.total_amount / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </MDTypography>
                            <MDTypography mt={0.4} variant="h6" fontWeight="light">
                              Total Collected
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                {breakdown !== null && (
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <VerticalBarChart
                      icon={{ color: "info", component: "trending_up" }}
                      title="Captures Trend"
                      description="Daily Count"
                      chart={{
                        labels: breakdown.days,
                        datasets: [
                          {
                            label: "Date",
                            color: "info",
                            data: breakdown.count,
                          },
                        ],
                      }}
                    />
                  </MDBox>
                )}
              </Grid>
            </Grid>
          </MDBox>

          {groupMetrics && (
            <MDBox mt={3}>
              <PieChart
                sx={{ height: "100%", marginTop: "0px" }}
                // icon={{ color: "info", component: "leaderboard" }}
                title="Team Performance"
                description=""
                chart={{
                  labels: getPieChartLabels(groupMetrics),
                  datasets: {
                    label: "Team Performance",
                    backgroundColors: getPieChartColors(groupMetrics),
                    data: getPieChartData(groupMetrics),
                  },
                }}
              />
            </MDBox>
          )}

          {supervisorMetrics && (
            <MDBox mt={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <PieChart
                    sx={{ height: "100%", marginTop: "0px" }}
                    // icon={{ color: "info", component: "leaderboard" }}
                    title="Supervisor Performance (Count)"
                    description=""
                    chart={{
                      labels: getPieChartLabels(supervisorMetrics.count),
                      datasets: {
                        label: "Supervisor Performance",
                        backgroundColors: getPieChartColors(supervisorMetrics.count),
                        data: getPieChartData(supervisorMetrics.count),
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <PieChart
                    sx={{ height: "100%", marginTop: "0px" }}
                    // icon={{ color: "info", component: "leaderboard" }}
                    title="Supervisor Performance (Volume)"
                    description=""
                    chart={{
                      labels: getPieChartLabels(supervisorMetrics.vol),
                      datasets: {
                        label: "Supervisor Performance",
                        backgroundColors: getPieChartColors(supervisorMetrics.vol),
                        data: getPieChartData(supervisorMetrics.vol),
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          )}

          {locationPoints.length > 0 && (
            <MDBox mt={5}>
              <Card>
                <MDBox p={3}>
                  <MDBox mb={3} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        Location HeatMap
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDButton
                        size="small"
                        variant="outlined"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          let pZoom = mapZoom;
                          pZoom -= 1;
                          pZoom = pZoom < 4 ? 4 : pZoom;
                          setMapZoom(pZoom);
                        }}
                      >
                        <Icon>remove</Icon>
                      </MDButton>
                      &nbsp;
                      <MDTypography variant="caption" fontSize={10} fontWeight="light">
                        Zoom
                      </MDTypography>
                      &nbsp;
                      <MDButton
                        size="small"
                        variant="outlined"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          let pZoom = mapZoom;
                          pZoom += 1;
                          pZoom = pZoom > 20 ? 20 : pZoom;
                          setMapZoom(pZoom);
                        }}
                      >
                        <Icon>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox sx={{ height: "65vh", width: "100%" }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                      defaultCenter={{
                        lat: locationPoints[0].lat, // 9.084576,
                        lng: locationPoints[0].lng, // 8.674252,
                      }}
                      defaultZoom={mapZoom}
                      zoom={mapZoom}
                    >
                      {locationPoints.map((loc) => (
                        // <AnyReactComponent
                        //   cRef={loc.reference}
                        //   lat={loc.lat}
                        //   lng={loc.lng}
                        //   text="My Marker"
                        // />
                        <MDBox
                          lat={loc.lat}
                          lng={loc.lng}
                          onClick={() => navigate(`/data-capture/${loc.reference}`)}
                        >
                          <MDTypography fontSize={24}>
                            <Icon color="error">location_on</Icon>
                          </MDTypography>
                        </MDBox>
                      ))}
                    </GoogleMapReact>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          )}

          {dataMetrics && (
            <MDBox mt={5} mb={5}>
              <MDBox align="center">
                <MDTypography fontSize={16}>Data Capture Insights</MDTypography>
              </MDBox>
              {dataMetrics.chartData && (
                <MDBox mt={4}>
                  <Grid container spacing={3}>
                    {dataMetrics.chartData.map((metric) => (
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox mb={0} sx={{ height: "100%", marginTop: "0px" }}>
                          <PieChart
                            sx={{ height: "100%", marginTop: "0px" }}
                            // icon={{ color: "info", component: "leaderboard" }}
                            title={metric.field.title}
                            description={metric.field.section}
                            chart={{
                              labels: getPieChartLabels(metric.metrics),
                              datasets: {
                                label: "Data Capture Insights",
                                backgroundColors: getPieChartColors(metric.metrics),
                                data: getPieChartData(metric.metrics),
                              },
                            }}
                          />
                        </MDBox>
                      </Grid>
                    ))}
                  </Grid>
                </MDBox>
              )}
              {dataMetrics.spreadData && (
                <>
                  {dataMetrics.spreadData.map((item) => (
                    <MDBox mt={5}>
                      <Card>
                        <MDBox p={3}>
                          <MDBox mb={3} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="bold">
                                {item.title}
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                {item.section}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                          <MDBox sx={{ height: "57vh", width: "100%" }}>
                            <GoogleMapReact
                              bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                              defaultCenter={{
                                lat: item.coords[0].lat, // 9.084576,
                                lng: item.coords[0].lng, // 8.674252,
                              }}
                              defaultZoom={mapZoom}
                              zoom={mapZoom}
                            >
                              {item.coords.map((loc) => (
                                <MDBox lat={loc.lat} lng={loc.lng}>
                                  <MDTypography fontSize={24}>
                                    <Icon color="error">location_on</Icon>
                                  </MDTypography>
                                </MDBox>
                              ))}
                            </GoogleMapReact>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ))}
                </>
              )}

              {dataMetrics.averageData && (
                <MDBox mt={6}>
                  <Grid container spacing={2}>
                    {dataMetrics.averageData.map((item) => (
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox>
                          <Card>
                            <MDBox p={3}>
                              <MDBox mb={3} display="flex" justifyContent="space-between">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold">
                                    {item.title}
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                                    {item.section}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                              <MDBox>
                                <MDBox align="center">
                                  <MDBox>
                                    <MDTypography variant="h6" fontWeight="bold" fontSize={18}>
                                      {item.figures.mod
                                        ? item.figures.mod.toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        : "---"}
                                    </MDTypography>
                                  </MDBox>
                                  <MDBox>
                                    <MDTypography variant="h6" fontWeight="light">
                                      Popular (Mod)
                                    </MDTypography>
                                  </MDBox>
                                </MDBox>
                                <MDBox mt={3}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={6} md={6} lg={6}>
                                      <MDBox align="center">
                                        <MDBox>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            fontSize={18}
                                          >
                                            {item.figures.sum.toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </MDTypography>
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography variant="h6" fontWeight="light">
                                            Sum
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                      <MDBox align="center">
                                        <MDBox>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            fontSize={18}
                                          >
                                            {item.figures.avg.toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </MDTypography>
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography variant="h6" fontWeight="light">
                                            Avg
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                      <MDBox align="center">
                                        <MDBox>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            fontSize={18}
                                          >
                                            {item.figures.max.toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </MDTypography>
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography variant="h6" fontWeight="light">
                                            Max
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                      <MDBox align="center">
                                        <MDBox>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            fontSize={18}
                                          >
                                            {item.figures.min.toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </MDTypography>
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography variant="h6" fontWeight="light">
                                            Min
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </Grid>
                                  </Grid>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </MDBox>
                      </Grid>
                    ))}
                  </Grid>
                </MDBox>
              )}

              {dataMetrics.downloadData && (
                <MDBox mt={6}>
                  <Grid container spacing={2}>
                    {dataMetrics.downloadData.map((item) => (
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox>
                          <Card>
                            <MDBox p={3}>
                              <MDBox mb={3} display="flex" justifyContent="space-between">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold">
                                    {item.title}
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                                    {item.section}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                              <MDBox>
                                <MDButton
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                  startIcon={<Icon>download</Icon>}
                                  onClick={() => {
                                    const downloadUrl = `${item.link}/${accountInfo.user.reference}`;
                                    window.open(downloadUrl, "_blank");
                                  }}
                                >
                                  Download All
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </MDBox>
                      </Grid>
                    ))}
                  </Grid>
                </MDBox>
              )}
            </MDBox>
          )}
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default DataCampaignOverview;
